<div class="modal-overlay">
  <div class="modal-box">

    <div class="modal-header">
      <i class="ft-log-out logout-icon"></i>
      <h3>Confirm Logout</h3>
    </div>

    <div class="modal-body">
      <p>Are you sure you want to logout?</p>
    </div>

    <div class="modal-footer">
      <button class="btn logout-btn" (click)="confirmLogout()">Logout</button>
    </div>

  </div>
</div>
